import { Injectable, computed, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class WaitIndicatorService {
    public loading = computed(() => this._i() > 0);
    private _i = signal(0);

    public show = (): void => {
        this._i.update(v => Math.max(0, v + 1));
    }
    public hide = (): void => {
        this._i.update(v => Math.max(0, v - 1));
    }
}
